import * as t from 'io-ts';
import { VehicleIdCodec } from '../sharedVehicleApi.types';

export const ServiceVehicleModelCodec = t.intersection([
    t.type({
        name: t.string,
    }),
    t.partial({
        group: t.string,
        version: t.string,
        manufacturer: t.string,
    }),
]);

export type ApiServiceVehicleModel = t.TypeOf<typeof ServiceVehicleModelCodec>;

export const ServiceVehicleCodec = t.intersection([
    t.type({
        id: VehicleIdCodec,
    }),
    t.partial({
        model: ServiceVehicleModelCodec,
    }),
]);

export type ApiServiceVehicle = t.TypeOf<typeof ServiceVehicleCodec>;
